import React from 'react';
import { Tooltip } from 'reactstrap';
import classNames from 'classnames';
import {ReactComponent as Documents} from '../images/svg_icons/documents.svg'

class DocumentsButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            printPreviewUrl: null,
            documents_tooltipOpen: false
        }
    }

    toggle = (key) => {
        this.setState({ [key]: !this.state[key] })
    }
     
    render() {
        const { listingId, count, isOpen } = this.props;
        return <button type="button" className={classNames('documents-button', { open: isOpen })} onClick={() => this.props.onDocumentsClicked()}>
            <Documents id={'documents_' + listingId} /> <span className="documents-count">{count}</span>
            <Tooltip delay={{ show: 0, hide: 0 }} isOpen={this.state.documents_tooltipOpen} toggle={() => this.toggle('documents_tooltipOpen')} placement="top"
                target={'documents_' + listingId} >
                Documents
            </Tooltip>
        </button>
    }
}

  export default DocumentsButton 